// extracted by mini-css-extract-plugin
export default {"controller":"controller__7ceee622","timer":"timer__7ceee622"};